// frontend/src/redux/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import monitorReducer from './slices/monitorSlice';
import signalReducer from './slices/signalSlice';
import uiReducer from './slices/uiSlice';
import tradingReducer from './slices/tradingSlice'; // ADD THIS

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'ui'] // only persist auth and ui state
};

const rootReducer = combineReducers({
  auth: authReducer,
  monitors: monitorReducer,
  signals: signalReducer,
  ui: uiReducer,
  trading: tradingReducer, // ADD THIS
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);